import { render, staticRenderFns } from "./works_edit.vue?vue&type=template&id=60e3e700&scoped=true&"
import script from "./works_edit.vue?vue&type=script&lang=js&"
export * from "./works_edit.vue?vue&type=script&lang=js&"
import style0 from "./works_edit.vue?vue&type=style&index=0&id=60e3e700&lang=scss&scoped=true&"
import style1 from "./works_edit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e3e700",
  null
  
)

export default component.exports